import React from "react";
import { Typography, Paper } from '@mui/material';

const Interests = ({ interests }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        height: '100%',
        borderRadius: 2,
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        p: 3
      }}
    >
      <Typography variant="h4" gutterBottom>Interests</Typography>
      <Typography
        variant="body1"
        sx={{
          flex: 1,
          overflow: 'auto'
        }}
      >
        {interests}
      </Typography>
    </Paper>
  );
};

export default Interests;